var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.022 1.128a.75.75 0 1 0-1.044 1.076l8.296 8.045H.875a.75.75 0 0 0 0 1.5h17.4l-8.297 8.045a.75.75 0 1 0 1.044 1.077l9.625-9.333a.75.75 0 0 0 .228-.536v-.003a.75.75 0 0 0-.229-.539l-9.624-9.332Z",
    fill: "#273943"
  })));
};
export default SvgNext;